import { useHavePermission } from "../../permission";
import { PERMISSIONS } from "../constants";

export const usePermissions = () => {
  const havePermission = useHavePermission();

  // CONFIG_PERM_USERS
  const havePerCreateConfigPermUsers = havePermission({
    [PERMISSIONS["CONFIG_PERM_USERS"]]: ({ C }) => C,
  });
  const havePerReadConfigPermUsers = havePermission({
    [PERMISSIONS["CONFIG_PERM_USERS"]]: ({ R }) => R,
  });
  const havePerUpdateConfigPermUsers = havePermission({
    [PERMISSIONS["CONFIG_PERM_USERS"]]: ({ U }) => U,
  });
  const havePerDeleteConfigPermUsers = havePermission({
    [PERMISSIONS["CONFIG_PERM_USERS"]]: ({ D }) => D,
  });
  const havePerUpdateOrDeleteConfigPermUsers = havePermission({
    [PERMISSIONS["CONFIG_PERM_USERS"]]: ({ U, D }) => U || D,
  });
  // CONFIG_PERM_APPROVERS
  const havePerCreateConfigPermApprovers = havePermission({
    [PERMISSIONS["CONFIG_PERM_APPROVERS"]]: ({ C }) => C,
  });
  const havePerReadConfigPermApprovers = havePermission({
    [PERMISSIONS["CONFIG_PERM_APPROVERS"]]: ({ R }) => R,
  });
  const havePerUpdateConfigPermApprovers = havePermission({
    [PERMISSIONS["CONFIG_PERM_APPROVERS"]]: ({ U }) => U,
  });
  const havePerDeleteConfigPermApprovers = havePermission({
    [PERMISSIONS["CONFIG_PERM_APPROVERS"]]: ({ D }) => D,
  });
  const havePerUpdateOrDeleteConfigPermApprovers = havePermission({
    [PERMISSIONS["CONFIG_PERM_APPROVERS"]]: ({ U, D }) => U || D,
  });
  // CONFIG_PERM_AFLS
  const havePerCreateConfigPermAFLs = havePermission({
    [PERMISSIONS["CONFIG_PERM_AFLS"]]: ({ C }) => C,
  });
  const havePerReadConfigPermAFLs = havePermission({
    [PERMISSIONS["CONFIG_PERM_AFLS"]]: ({ R }) => R,
  });
  const havePerUpdateConfigPermAFLs = havePermission({
    [PERMISSIONS["CONFIG_PERM_AFLS"]]: ({ U }) => U,
  });
  const havePerDeleteConfigPermAFLs = havePermission({
    [PERMISSIONS["CONFIG_PERM_AFLS"]]: ({ D }) => D,
  });
  const havePerUpdateOrDeleteConfigPermAFLs = havePermission({
    [PERMISSIONS["CONFIG_PERM_AFLS"]]: ({ U, D }) => U || D,
  });

  // ACCOUNT_DELETE_GRANTED
  const havePerCreateAccountDeleteGranted = havePermission({
    [PERMISSIONS["ACCOUNT_DELETE_GRANTED"]]: ({ C }) => C,
  });
  const havePerReadAccountDeleteGranted = havePermission({
    [PERMISSIONS["ACCOUNT_DELETE_GRANTED"]]: ({ R }) => R,
  });
  const havePerUpdateAccountDeleteGranted = havePermission({
    [PERMISSIONS["ACCOUNT_DELETE_GRANTED"]]: ({ U }) => U,
  });
  const havePerDeleteAccountDeleteGranted = havePermission({
    [PERMISSIONS["ACCOUNT_DELETE_GRANTED"]]: ({ D }) => D,
  });
  const havePerUpdateOrDeleteAccountDeleteGranted = havePermission({
    [PERMISSIONS["ACCOUNT_DELETE_GRANTED"]]: ({ U, D }) => U || D,
  });

  // SABRE_EPR_GRANTED
  const havePerCreateSabreEPRGranted = havePermission({
    [PERMISSIONS["SABRE_EPR_GRANTED"]]: ({ C }) => C,
  });
  const havePerReadSabreEPRGranted = havePermission({
    [PERMISSIONS["SABRE_EPR_GRANTED"]]: ({ R }) => R,
  });
  const havePerUpdateSabreEPRGranted = havePermission({
    [PERMISSIONS["SABRE_EPR_GRANTED"]]: ({ U }) => U,
  });
  const havePerDeleteSabreEPRGranted = havePermission({
    [PERMISSIONS["SABRE_EPR_GRANTED"]]: ({ D }) => D,
  });
  const havePerUpdateOrDeleteSabreEPRGranted = havePermission({
    [PERMISSIONS["SABRE_EPR_GRANTED"]]: ({ D, U }) => D || U,
  });
  // IT_PROGRAM_GRANTED
  const havePerCreateITProgramGranted = havePermission({
    [PERMISSIONS["IT_PROGRAM_GRANTED"]]: ({ C }) => C,
  });
  const havePerReadITProgramGranted = havePermission({
    [PERMISSIONS["IT_PROGRAM_GRANTED"]]: ({ R }) => R,
  });
  const havePerUpdateITProgramGranted = havePermission({
    [PERMISSIONS["IT_PROGRAM_GRANTED"]]: ({ U }) => U,
  });
  const havePerDeleteITProgramGranted = havePermission({
    [PERMISSIONS["IT_PROGRAM_GRANTED"]]: ({ D }) => D,
  });
  const havePerUpdateOrDeleteITProgramGranted = havePermission({
    [PERMISSIONS["IT_PROGRAM_GRANTED"]]: ({ D, U }) => D || U,
  });
  // REPAIR_TOOL_GRANTED
  const havePerCreateRepairToolGranted = havePermission({
    [PERMISSIONS["REPAIR_TOOL_GRANTED"]]: ({ C }) => C,
  });
  const havePerReadRepairToolGranted = havePermission({
    [PERMISSIONS["REPAIR_TOOL_GRANTED"]]: ({ R }) => R,
  });
  const havePerUpdateRepairToolGranted = havePermission({
    [PERMISSIONS["REPAIR_TOOL_GRANTED"]]: ({ U }) => U,
  });
  const havePerDeleteRepairToolGranted = havePermission({
    [PERMISSIONS["REPAIR_TOOL_GRANTED"]]: ({ D }) => D,
  });
  const havePerUpdateOrDeleteRepairToolGranted = havePermission({
    [PERMISSIONS["REPAIR_TOOL_GRANTED"]]: ({ D, U }) => D || U,
  });
  // DEMAND_FOR_SUPPLIES
  const havePerCreateDemandForSupplies = havePermission({
    [PERMISSIONS["DEMAND_FOR_SUPPLIES"]]: ({ C }) => C,
  });
  const havePerReadDemandForSupplies = havePermission({
    [PERMISSIONS["DEMAND_FOR_SUPPLIES"]]: ({ R }) => R,
  });
  const havePerUpdateDemandForSupplies = havePermission({
    [PERMISSIONS["DEMAND_FOR_SUPPLIES"]]: ({ U }) => U,
  });
  const havePerDeleteDemandForSupplies = havePermission({
    [PERMISSIONS["DEMAND_FOR_SUPPLIES"]]: ({ D }) => D,
  });
  const havePerUpdateOrDeleteDemandForSupplies = havePermission({
    [PERMISSIONS["DEMAND_FOR_SUPPLIES"]]: ({ D, U }) => D || U,
  });
  // BUSINESS_TICKETS
  const havePerCreateBusinessTickets = havePermission({
    [PERMISSIONS["BUSINESS_TICKETS"]]: ({ C }) => C,
  });
  const havePerReadBusinessTickets = havePermission({
    [PERMISSIONS["BUSINESS_TICKETS"]]: ({ R }) => R,
  });
  const havePerUpdateBusinessTickets = havePermission({
    [PERMISSIONS["BUSINESS_TICKETS"]]: ({ U }) => U,
  });
  const havePerDeleteBusinessTickets = havePermission({
    [PERMISSIONS["BUSINESS_TICKETS"]]: ({ D }) => D,
  });
  const havePerUpdateOrDeleteBusinessTickets = havePermission({
    [PERMISSIONS["BUSINESS_TICKETS"]]: ({ D, U }) => D || U,
  });
  // SECURITY_CONTROL_CARD
  const havePerCreateSecurityControlCard = havePermission({
    [PERMISSIONS["SECURITY_CONTROL_CARD"]]: ({ C }) => C,
  });
  const havePerReadSecurityControlCard = havePermission({
    [PERMISSIONS["SECURITY_CONTROL_CARD"]]: ({ R }) => R,
  });
  const havePerUpdateSecurityControlCard = havePermission({
    [PERMISSIONS["SECURITY_CONTROL_CARD"]]: ({ U }) => U,
  });
  const havePerDeleteSecurityControlCard = havePermission({
    [PERMISSIONS["SECURITY_CONTROL_CARD"]]: ({ D }) => D,
  });
  const havePerUpdateOrDeleteSecurityControlCard = havePermission({
    [PERMISSIONS["SECURITY_CONTROL_CARD"]]: ({ D, U }) => D || U,
  });
  // SECURITY_CARDS_EXTERNAL
  const havePerCreateSecurityCardsExternal = havePermission({
    [PERMISSIONS["SECURITY_CARDS_EXTERNAL"]]: ({ C }) => C,
  });
  const havePerReadSecurityCardsExternal = havePermission({
    [PERMISSIONS["SECURITY_CARDS_EXTERNAL"]]: ({ R }) => R,
  });
  const havePerUpdateSecurityCardsExternal = havePermission({
    [PERMISSIONS["SECURITY_CARDS_EXTERNAL"]]: ({ U }) => U,
  });
  const havePerDeleteSecurityCardsExternal = havePermission({
    [PERMISSIONS["SECURITY_CARDS_EXTERNAL"]]: ({ D }) => D,
  });
  const havePerUpdateOrDeleteSecurityCardsExternal = havePermission({
    [PERMISSIONS["SECURITY_CARDS_EXTERNAL"]]: ({ D, U }) => D || U,
  });
  // BUSINESS_VEHICLE_CARD
  const havePerCreateBusinessVehicleCard = havePermission({
    [PERMISSIONS["BUSINESS_VEHICLE_CARD"]]: ({ C }) => C,
  });
  const havePerReadBusinessVehicleCard = havePermission({
    [PERMISSIONS["BUSINESS_VEHICLE_CARD"]]: ({ R }) => R,
  });
  const havePerUpdateBusinessVehicleCard = havePermission({
    [PERMISSIONS["BUSINESS_VEHICLE_CARD"]]: ({ U }) => U,
  });
  const havePerDeleteBusinessVehicleCard = havePermission({
    [PERMISSIONS["BUSINESS_VEHICLE_CARD"]]: ({ D }) => D,
  });
  const havePerUpdateOrDeleteBusinessVehicleCard = havePermission({
    [PERMISSIONS["BUSINESS_VEHICLE_CARD"]]: ({ D, U }) => D || U,
  });
  // EXTERNAL_BUSINESS_VEHICLE_CARD
  const havePerCreateExternalBusinessVehicleCard = havePermission({
    [PERMISSIONS["EXTERNAL_BUSINESS_VEHICLE_CARD"]]: ({ C }) => C,
  });
  const havePerReadExternalBusinessVehicleCard = havePermission({
    [PERMISSIONS["EXTERNAL_BUSINESS_VEHICLE_CARD"]]: ({ R }) => R,
  });
  const havePerUpdateExternalBusinessVehicleCard = havePermission({
    [PERMISSIONS["EXTERNAL_BUSINESS_VEHICLE_CARD"]]: ({ U }) => U,
  });
  const havePerDeleteExternalBusinessVehicleCard = havePermission({
    [PERMISSIONS["EXTERNAL_BUSINESS_VEHICLE_CARD"]]: ({ D }) => D,
  });
  const havePerUpdateOrDeleteExternalBusinessVehicleCard = havePermission({
    [PERMISSIONS["EXTERNAL_BUSINESS_VEHICLE_CARD"]]: ({ D, U }) => D || U,
  });
  // BUSINESS_VEHICLE
  const havePerCreateBusinessVehicle = havePermission({
    [PERMISSIONS["BUSINESS_VEHICLE"]]: ({ C }) => C,
  });
  const havePerReadBusinessVehicle = havePermission({
    [PERMISSIONS["BUSINESS_VEHICLE"]]: ({ R }) => R,
  });
  const havePerUpdateBusinessVehicle = havePermission({
    [PERMISSIONS["BUSINESS_VEHICLE"]]: ({ U }) => U,
  });
  const havePerDeleteBusinessVehicle = havePermission({
    [PERMISSIONS["BUSINESS_VEHICLE"]]: ({ D }) => D,
  });
  const havePerUpdateOrDeleteBusinessVehicle = havePermission({
    [PERMISSIONS["BUSINESS_VEHICLE"]]: ({ D, U }) => D || U,
  });
  // ABSENCE_LETTER
  const havePerCreateAbsenceLetter = havePermission({
    [PERMISSIONS["ABSENCE_LETTER"]]: ({ C }) => C,
  });
  const havePerReadAbsenceLetter = havePermission({
    [PERMISSIONS["ABSENCE_LETTER"]]: ({ R }) => R,
  });
  const havePerUpdateAbsenceLetter = havePermission({
    [PERMISSIONS["ABSENCE_LETTER"]]: ({ U }) => U,
  });
  const havePerDeleteAbsenceLetter = havePermission({
    [PERMISSIONS["ABSENCE_LETTER"]]: ({ D }) => D,
  });
  // NO_SALARY_LEAVE_TSN
  const havePerCreateNoSalaryLeaveTSN = havePermission({
    [PERMISSIONS["NO_SALARY_LEAVE_TSN"]]: ({ C }) => C,
  });
  const havePerReadNoSalaryLeaveTSN = havePermission({
    [PERMISSIONS["NO_SALARY_LEAVE_TSN"]]: ({ R }) => R,
  });
  const havePerUpdateNoSalaryLeaveTSN = havePermission({
    [PERMISSIONS["NO_SALARY_LEAVE_TSN"]]: ({ U }) => U,
  });
  const havePerDeleteNoSalaryLeaveTSN = havePermission({
    [PERMISSIONS["NO_SALARY_LEAVE_TSN"]]: ({ D }) => D,
  });
  // SUSPEND_CONTRACT_TSN
  const havePerCreateSuspendContractTSN = havePermission({
    [PERMISSIONS["SUSPEND_CONTRACT_TSN"]]: ({ C }) => C,
  });
  const havePerReadSuspendContractTSN = havePermission({
    [PERMISSIONS["SUSPEND_CONTRACT_TSN"]]: ({ R }) => R,
  });
  const havePerUpdateSuspendContractTSN = havePermission({
    [PERMISSIONS["SUSPEND_CONTRACT_TSN"]]: ({ U }) => U,
  });
  const havePerDeleteSuspendContractTSN = havePermission({
    [PERMISSIONS["SUSPEND_CONTRACT_TSN"]]: ({ D }) => D,
  });
  // TERMINATION_CONTRACT_TSN
  const havePerCreateTerminationContractTSN = havePermission({
    [PERMISSIONS["TERMINATION_CONTRACT_TSN"]]: ({ C }) => C,
  });
  const havePerReadTerminationContractTSN = havePermission({
    [PERMISSIONS["TERMINATION_CONTRACT_TSN"]]: ({ R }) => R,
  });
  const havePerUpdateTerminationContractTSN = havePermission({
    [PERMISSIONS["TERMINATION_CONTRACT_TSN"]]: ({ U }) => U,
  });
  const havePerDeleteTerminationContractTSN = havePermission({
    [PERMISSIONS["TERMINATION_CONTRACT_TSN"]]: ({ D }) => D,
  });
  // ABSENCE_LETTER_NBA
  const havePerCreateAbsenceLetterNBA = havePermission({
    [PERMISSIONS["ABSENCE_LETTER_NBA"]]: ({ C }) => C,
  });
  const havePerReadAbsenceLetterNBA = havePermission({
    [PERMISSIONS["ABSENCE_LETTER_NBA"]]: ({ R }) => R,
  });
  const havePerUpdateAbsenceLetterNBA = havePermission({
    [PERMISSIONS["ABSENCE_LETTER_NBA"]]: ({ U }) => U,
  });
  const havePerDeleteAbsenceLetterNBA = havePermission({
    [PERMISSIONS["ABSENCE_LETTER_NBA"]]: ({ D }) => D,
  });
  // ABSENCE_LETTER_DAD
  const havePerCreateAbsenceLetterDAD = havePermission({
    [PERMISSIONS["ABSENCE_LETTER_DAD"]]: ({ C }) => C,
  });
  const havePerReadAbsenceLetterDAD = havePermission({
    [PERMISSIONS["ABSENCE_LETTER_DAD"]]: ({ R }) => R,
  });
  const havePerUpdateAbsenceLetterDAD = havePermission({
    [PERMISSIONS["ABSENCE_LETTER_DAD"]]: ({ U }) => U,
  });
  const havePerDeleteAbsenceLetterDAD = havePermission({
    [PERMISSIONS["ABSENCE_LETTER_DAD"]]: ({ D }) => D,
  });
  // MATERNITY_LEAVE_DAD
  const havePerCreateMaternityLeaveDAD = havePermission({
    [PERMISSIONS["MATERNITY_LEAVE_DAD"]]: ({ C }) => C,
  });
  const havePerReadMaternityLeaveDAD = havePermission({
    [PERMISSIONS["MATERNITY_LEAVE_DAD"]]: ({ R }) => R,
  });
  const havePerUpdateMaternityLeaveDAD = havePermission({
    [PERMISSIONS["MATERNITY_LEAVE_DAD"]]: ({ U }) => U,
  });
  const havePerDeleteMaternityLeaveDAD = havePermission({
    [PERMISSIONS["MATERNITY_LEAVE_DAD"]]: ({ D }) => D,
  });
  // SICK_LEAVE_DAD
  const havePerCreateSickLeaveDAD = havePermission({
    [PERMISSIONS["SICK_LEAVE_DAD"]]: ({ C }) => C,
  });
  const havePerReadSickLeaveDAD = havePermission({
    [PERMISSIONS["SICK_LEAVE_DAD"]]: ({ R }) => R,
  });
  const havePerUpdateSickLeaveDAD = havePermission({
    [PERMISSIONS["SICK_LEAVE_DAD"]]: ({ U }) => U,
  });
  const havePerDeleteSickLeaveDAD = havePermission({
    [PERMISSIONS["SICK_LEAVE_DAD"]]: ({ D }) => D,
  });
  // NO_SALARY_LEAVE_DAD
  const havePerCreateNoSalaryLeaveDAD = havePermission({
    [PERMISSIONS["NO_SALARY_LEAVE_DAD"]]: ({ C }) => C,
  });
  const havePerReadNoSalaryLeaveDAD = havePermission({
    [PERMISSIONS["NO_SALARY_LEAVE_DAD"]]: ({ R }) => R,
  });
  const havePerUpdateNoSalaryLeaveDAD = havePermission({
    [PERMISSIONS["NO_SALARY_LEAVE_DAD"]]: ({ U }) => U,
  });
  const havePerDeleteNoSalaryLeaveDAD = havePermission({
    [PERMISSIONS["NO_SALARY_LEAVE_DAD"]]: ({ D }) => D,
  });
  // SUSPEND_CONTRACT_DAD
  const havePerCreateSuspendContractDAD = havePermission({
    [PERMISSIONS["SUSPEND_CONTRACT_DAD"]]: ({ C }) => C,
  });
  const havePerReadSuspendContractDAD = havePermission({
    [PERMISSIONS["SUSPEND_CONTRACT_DAD"]]: ({ R }) => R,
  });
  const havePerUpdateSuspendContractDAD = havePermission({
    [PERMISSIONS["SUSPEND_CONTRACT_DAD"]]: ({ U }) => U,
  });
  const havePerDeleteSuspendContractDAD = havePermission({
    [PERMISSIONS["SUSPEND_CONTRACT_DAD"]]: ({ D }) => D,
  });
  // TERMINATION_CONTRACT_DAD
  const havePerCreateTerminationContractDAD = havePermission({
    [PERMISSIONS["TERMINATION_CONTRACT_DAD"]]: ({ C }) => C,
  });
  const havePerReadTerminationContractDAD = havePermission({
    [PERMISSIONS["TERMINATION_CONTRACT_DAD"]]: ({ R }) => R,
  });
  const havePerUpdateTerminationContractDAD = havePermission({
    [PERMISSIONS["TERMINATION_CONTRACT_DAD"]]: ({ U }) => U,
  });
  const havePerDeleteTerminationContractDAD = havePermission({
    [PERMISSIONS["TERMINATION_CONTRACT_DAD"]]: ({ D }) => D,
  });

  return {
    havePerCreateAccountDeleteGranted,
    havePerReadAccountDeleteGranted,
    havePerUpdateAccountDeleteGranted,
    havePerDeleteAccountDeleteGranted,
    havePerCreateSabreEPRGranted,
    havePerReadSabreEPRGranted,
    havePerUpdateSabreEPRGranted,
    havePerDeleteSabreEPRGranted,
    havePerCreateITProgramGranted,
    havePerReadITProgramGranted,
    havePerUpdateITProgramGranted,
    havePerDeleteITProgramGranted,
    havePerCreateRepairToolGranted,
    havePerReadRepairToolGranted,
    havePerUpdateRepairToolGranted,
    havePerDeleteRepairToolGranted,
    havePerCreateDemandForSupplies,
    havePerReadDemandForSupplies,
    havePerUpdateDemandForSupplies,
    havePerDeleteDemandForSupplies,
    havePerCreateBusinessTickets,
    havePerReadBusinessTickets,
    havePerUpdateBusinessTickets,
    havePerDeleteBusinessTickets,
    havePerCreateSecurityControlCard,
    havePerReadSecurityControlCard,
    havePerUpdateSecurityControlCard,
    havePerDeleteSecurityControlCard,
    havePerCreateSecurityCardsExternal,
    havePerReadSecurityCardsExternal,
    havePerUpdateSecurityCardsExternal,
    havePerDeleteSecurityCardsExternal,
    havePerCreateBusinessVehicleCard,
    havePerReadBusinessVehicleCard,
    havePerUpdateBusinessVehicleCard,
    havePerDeleteBusinessVehicleCard,
    havePerCreateExternalBusinessVehicleCard,
    havePerReadExternalBusinessVehicleCard,
    havePerUpdateExternalBusinessVehicleCard,
    havePerDeleteExternalBusinessVehicleCard,
    havePerCreateBusinessVehicle,
    havePerReadBusinessVehicle,
    havePerUpdateBusinessVehicle,
    havePerDeleteBusinessVehicle,
    havePerCreateAbsenceLetter,
    havePerReadAbsenceLetter,
    havePerUpdateAbsenceLetter,
    havePerDeleteAbsenceLetter,
    havePerCreateNoSalaryLeaveTSN,
    havePerReadNoSalaryLeaveTSN,
    havePerUpdateNoSalaryLeaveTSN,
    havePerDeleteNoSalaryLeaveTSN,
    havePerCreateSuspendContractTSN,
    havePerReadSuspendContractTSN,
    havePerUpdateSuspendContractTSN,
    havePerDeleteSuspendContractTSN,
    havePerCreateTerminationContractTSN,
    havePerReadTerminationContractTSN,
    havePerUpdateTerminationContractTSN,
    havePerDeleteTerminationContractTSN,
    havePerCreateAbsenceLetterNBA,
    havePerReadAbsenceLetterNBA,
    havePerUpdateAbsenceLetterNBA,
    havePerDeleteAbsenceLetterNBA,
    havePerCreateAbsenceLetterDAD,
    havePerReadAbsenceLetterDAD,
    havePerUpdateAbsenceLetterDAD,
    havePerDeleteAbsenceLetterDAD,
    havePerCreateMaternityLeaveDAD,
    havePerReadMaternityLeaveDAD,
    havePerUpdateMaternityLeaveDAD,
    havePerDeleteMaternityLeaveDAD,
    havePerCreateSickLeaveDAD,
    havePerReadSickLeaveDAD,
    havePerUpdateSickLeaveDAD,
    havePerDeleteSickLeaveDAD,
    havePerCreateNoSalaryLeaveDAD,
    havePerReadNoSalaryLeaveDAD,
    havePerUpdateNoSalaryLeaveDAD,
    havePerDeleteNoSalaryLeaveDAD,
    havePerCreateSuspendContractDAD,
    havePerReadSuspendContractDAD,
    havePerUpdateSuspendContractDAD,
    havePerDeleteSuspendContractDAD,
    havePerCreateTerminationContractDAD,
    havePerReadTerminationContractDAD,
    havePerUpdateTerminationContractDAD,
    havePerDeleteTerminationContractDAD,
    havePerUpdateOrDeleteAccountDeleteGranted,
    havePerUpdateOrDeleteSabreEPRGranted,
    havePerUpdateOrDeleteITProgramGranted,
    havePerUpdateOrDeleteRepairToolGranted,
    havePerUpdateOrDeleteDemandForSupplies,
    havePerUpdateOrDeleteBusinessTickets,
    havePerUpdateOrDeleteSecurityControlCard,
    havePerUpdateOrDeleteSecurityCardsExternal,
    havePerUpdateOrDeleteBusinessVehicleCard,
    havePerUpdateOrDeleteExternalBusinessVehicleCard,
    havePerUpdateOrDeleteBusinessVehicle,
    havePerCreateConfigPermUsers,
    havePerReadConfigPermUsers,
    havePerUpdateConfigPermUsers,
    havePerDeleteConfigPermUsers,
    havePerUpdateOrDeleteConfigPermUsers,
    havePerCreateConfigPermApprovers,
    havePerReadConfigPermApprovers,
    havePerUpdateConfigPermApprovers,
    havePerDeleteConfigPermApprovers,
    havePerUpdateOrDeleteConfigPermApprovers,
    havePerCreateConfigPermAFLs,
    havePerReadConfigPermAFLs,
    havePerUpdateConfigPermAFLs,
    havePerDeleteConfigPermAFLs,
    havePerUpdateOrDeleteConfigPermAFLs,
  };
};
